module.exports = __webpack_public_path__ + "6865e100e7c839d0e3565edd02319647.svg";